import { ReactNode } from 'react'
import { Link } from 'react-router-dom'
import Icon from 'src/components/icons/icon'

interface PageHeaderProps {
  title?: string
  description?: string | ReactNode
  testid?: string
  image?: ReactNode
  imageSource?: string
  imageAlt?: string
  imageClassName?: string
  actions?: ReactNode
  titleBefore?: ReactNode
  titleAfter?: ReactNode
  backText?: string
  backLink?: string
}

export default function PageHeader({
  title = '',
  description = '',
  testid = '',
  image = null,
  imageSource = '',
  imageAlt = '',
  imageClassName = '',
  actions,
  titleBefore,
  titleAfter,
  backText = '',
  backLink = '',
}: PageHeaderProps) {
  return (
    <div className='relative flex justify-between p-12 pb-0'>
      <div className='flex-1'>
        {backLink && (
          <Link
            to={backLink}
            relative='path'
            className='text-link -mt-4 mb-1 flex w-fit items-center text-xs font-bold'
          >
            <Icon name='lucide-chevron-left' className={'mr-1'} size={16} />
            {backText || 'Back'}
          </Link>
        )}
        <div className='flex'>
          {image && <div className='mr-4 shrink-0'>{image}</div>}
          {imageSource && (
            <img className={`shrink-0 ${imageClassName}`} src={imageSource} alt={imageAlt} width='56' height='56' />
          )}
          <div className='space-y-1'>
            <h2 className='h2 flex items-center space-x-2' data-testid={testid}>
              {titleBefore && <div className='font-sans font-normal'>{titleBefore}</div>}
              <span className='break-all'>{title}</span>
              {titleAfter && <div className='font-sans font-normal'>{titleAfter}</div>}
            </h2>
            {description && <div className='text-light'>{description}</div>}
          </div>
        </div>
      </div>
      <div className='flex items-center'>{actions}</div>
    </div>
  )
}
